import { createRouter as createVueRouter, createWebHashHistory } from 'vue-router'
import ViewerView from '@/views/LeadViewer.vue'
import HomeView from '@/views/HomeView.vue';
// import msalInstance from "../auth/msal"
import { useMainStore } from '@/store'


// const requiredRole = process.env.VUE_APP_LS_KEYCLOAK_REQUIRED_ROLE;
// const frontendClient = process.env.VUE_APP_LS_KEYCLOAK_MAIN_FRONTEND_CLIENT;

// const isAuthorized = () => {
//   const account = msalInstance.getActiveAccount()
//   return !!account
// };

const isAuthorized = () => {
  const store = useMainStore()
  return store.authenticated 
}

// eslint-disable-next-line no-unused-vars
const createRouter = (app) => {
  const router = createVueRouter({
    history: createWebHashHistory(),
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { top: 0 };
      }
    },
    routes: [
      {
        path: '/',
        name: 'Home',
        component: HomeView,
        // eslint-disable-next-line no-unused-vars
        beforeEnter: (to, from) => {
          if (isAuthorized()) {
            return ({ name: 'viewer' });
          }
        },
      },
      {
        path: '/viewer',
        name: 'viewer',
        component: ViewerView,
        // eslint-disable-next-line no-unused-vars
        beforeEnter: (to, from) => {
          if (!isAuthorized()) {
            return ({ name: 'Home' });
          }
        },
      }
    ]
  });
  return router;
};

export {
  createRouter
}
